var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.download}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-down","fixed-width":""}}),_vm._v(" "+_vm._s(_vm.$t('buttons.download')))],1)}
var staticRenderFns = []

export { render, staticRenderFns }